

























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class CobaPasienList extends Vue {
  search = "";
  calories = "";
  filterCategory = "";
  filterName = "";

  categoryOptions = [
    { id: 1, name: "Lite" },
    { id: 2, name: "Medium" },
    { id: 3, name: "Hard" }
  ];

  desserts = [
    {
      name: "Frozen Yogurt",
      calories: 159,
      fat: 6.0,
      carbs: 24,
      protein: 4.0,
      iron: "1%",
      category: "Lite"
    },
    {
      name: "Ice cream sandwich",
      calories: 237,
      fat: 9.0,
      carbs: 37,
      protein: 4.3,
      iron: "1%",
      category: "Medium"
    },
    {
      name: "Eclair",
      calories: 262,
      fat: 16.0,
      carbs: 23,
      protein: 6.0,
      iron: "7%",
      category: "Hard"
    },
    {
      name: "Cupcake",
      calories: 305,
      fat: 3.7,
      carbs: 67,
      protein: 4.3,
      iron: "8%",
      category: "Lite"
    },
    {
      name: "Gingerbread",
      calories: 356,
      fat: 16.0,
      carbs: 49,
      protein: 3.9,
      iron: "16%",
      category: "Medium"
    },
    {
      name: "Jelly bean",
      calories: 375,
      fat: 0.0,
      carbs: 94,
      protein: 0.0,
      iron: "0%",
      category: "Hard"
    },
    {
      name: "Lollipop",
      calories: 392,
      fat: 0.2,
      carbs: 98,
      protein: 0,
      iron: "2%",
      category: "Lite"
    },
    {
      name: "Honeycomb",
      calories: 408,
      fat: 3.2,
      carbs: 87,
      protein: 6.5,
      iron: "45%",
      category: "Medium"
    },
    {
      name: "Donut",
      calories: 452,
      fat: 25.0,
      carbs: 51,
      protein: 4.9,
      iron: "22%",
      category: "Hard"
    },
    {
      name: "KitKat",
      calories: 518,
      fat: 26.0,
      carbs: 65,
      protein: 7,
      iron: "6%",
      category: "Lite"
    }
  ];

  get headers() {
    return [
      {
        text: "Dessert (100g serving)",
        align: "start",
        sortable: false,
        value: "name",
        filter: value => {
          if (!this.filterName) return true;

          return (
            typeof value === "string" &&
            value
              .toString()
              .toLowerCase()
              .includes(this.filterName.toLowerCase())
          );
        }
      },
      {
        text: "Category",
        value: "category",
        filter: value => {
          if (!this.filterCategory) return true;

          return (
            typeof value === "string" &&
            // value.toString().indexOf(this.filterCategory) !== -1
            value
              .toString()
              .toLowerCase()
              .includes(this.filterCategory.toLowerCase())
          );
        }
      },
      {
        text: "Calories",
        value: "calories",
        filter: value => {
          if (!this.calories) return true;

          return value < parseInt(this.calories);
        }
      },
      { text: "Fat (g)", value: "fat" },
      { text: "Carbs (g)", value: "carbs" },
      { text: "Protein (g)", value: "protein" },
      { text: "Iron (%)", value: "iron" }
    ];
  }

  filterOnlyCapsText(value, search, item) {
    return (
      value != null &&
      search != null &&
      typeof value === "string" &&
      value
        .toString()
        .toLocaleUpperCase()
        .indexOf(search) !== -1
    );
  }
}
